import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isObject } from 'lodash/fp';
import { formatNumber } from '../../../../../helpers/i18n';

import cn from './styles.local.less';

export default class DefaultRangeLabel extends PureComponent {
  static propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.number,
      PropTypes.string,
    ]),
    valueLabel: PropTypes.string,
  };

  getFormattedValue() {
    const { value } = this.props;

    return isObject(value)
      ? `${formatNumber(Number(value.min))} - ${formatNumber(
          Number(value.max),
        )}`
      : formatNumber(Number(value));
  }

  render() {
    const { valueLabel } = this.props;

    return (
      <div className={cn.root} data-qa-selector="range-label">
        {this.getFormattedValue()} {valueLabel}
      </div>
    );
  }
}
